import React from 'react';
import GeraeteComponent from "../Components/Taetigkeitsbericht/GeraeteComponent";
import {getToken} from "../Utils/Common";


const GeraetePage = () => {


    const [deviceList, setDeviceList] = React.useState([{
        "id": null,
        "name": "",
        "status": false
    }]);

    React.useEffect(async () => {
        let orgID = sessionStorage.getItem("org")
        let agData = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/getdevices", {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({token: getToken(), data: {organisationID: orgID}}),
        })
            .then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            });
        setDeviceList(agData.data)

    }, [])


    return (
        <div className="handwai-dark"
             style={{
                 height: '94vh',
                 width: '100vw',
                 overflowY: 'scroll',
                 overflowX: 'hidden',
             }}
        >

            <br/>

            <GeraeteComponent
                deviceList={deviceList}
                setDeviceList={setDeviceList}
            />

            <br/> <br/>


            <br/> <br/>
        </div>
    );
}

export default GeraetePage;